import { IIncomeMutation } from 'services/cash-flow/income/types';
import { ICashFlowForm } from 'services/cash-flow/types';

export const incomeFormToQuery = (form: ICashFlowForm): IIncomeMutation => {
  const {
    settlementName,
    name,
    fileUrl,
    repayments,
    file,
    remainingNetAmount,
    repaymentsFromAllContracts,
    contracts,
    ...income
  } = {
    ...form,
    incomeName: form.name,
    settlementId: '0f0c35ac-7026-4332-9e21-e79c83e616f9',
  };

  return income;
};
